import List from '@mui/material/List';
import { ViewItem } from '../ViewItem';
import {
  Typography,
  Button,
  Pagination
} from '@mui/material';
import React , { useEffect, useState } from 'react';

const ViewsList = ({views, handleClick}:{views:any[], handleClick: (e: any) => void}) => {
  const itemsPerPage = 3;
  const [page, setPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(page - 1);
  const nItems = views.length;
  const pageCount = Math.ceil(nItems / itemsPerPage);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setPage(value);
  };

  return nItems > 0 ? (
    <>
      <List disablePadding sx={{ mb: 1 }}>
        {views.slice(itemOffset, itemOffset + itemsPerPage).map((item, index) => (
          <ViewItem item={item} key={index} />
        ))}
      </List>
      { pageCount > 1 && (
        <Pagination 
          onChange={handlePageClick}
          count={pageCount}
          page={page}
          size="small"
          variant="outlined" 
          shape="rounded"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            position: 'absolute',
            bottom: '10px'
          }}
        />
      )}
    </>
  ) : (
    <div style={{display: "flex", flexDirection: 'column', gap: '15px', alignItems: 'center', justifyContent: 'center', padding: '10px 0 50px 0', height: '284px'}}>
      <Typography
          fontSize={'13px'}
          variant={'body1'}
          color={'text.secondary'}
      >
          No Views found
      </Typography>
      <Button
        size={'small'}
        variant={'outlined'}
        onClick={handleClick} 
        style={{height: '25px', boxShadow: 'none', minWidth: 'auto'/*,  backgroundColor: '#7b6dc4'*/}}
      >
        Create New View
      </Button>
    </div>
  );;
};

export { ViewsList };
